import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function GrafHistoricosInv() {
    const { t } = useTranslation();
    // Estados para las fechas seleccionadas
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // Estados para las fechas confirmadas
    const [confirmedStartDate, setConfirmedStartDate] = useState('');
    const [confirmedEndDate, setConfirmedEndDate] = useState('');

    // Estados para var-ct y var-IdInverter seleccionados
    const [selectedCt, setSelectedCt] = useState(1); // Valor inicial de var-ct
    const [selectedInverter, setSelectedInverter] = useState(1); // Valor inicial de var-IdInverter

    // Función para convertir la fecha a milisegundos
    const dateToMilliseconds = (date) => {
        return new Date(date).getTime();
    };

    // URLs de los paneles con las fechas confirmadas en milisegundos
    const from = confirmedStartDate ? dateToMilliseconds(confirmedStartDate) : 'now-720m';
    const to = confirmedEndDate ? dateToMilliseconds(confirmedEndDate) : 'now';

    // Función para confirmar las fechas seleccionadas
    const handleConfirm = () => {
        setConfirmedStartDate(startDate);
        setConfirmedEndDate(endDate);
    };

    // Función para resetear las fechas a valores predeterminados
    const handleReset = () => {
        setStartDate('');
        setEndDate('');
        setConfirmedStartDate('');
        setConfirmedEndDate('');
    };

    return (
        <>
            <div className="container-fluid">
                {/* Selección de valores var-ct y var-IdInverter */}
                <div className="row mb-3">
                    <div className="col col-3">
                        <label>CT:&nbsp;</label>
                        <select
                            value={selectedCt}
                            onChange={(e) => setSelectedCt(e.target.value)}
                            className="form-select"
                        >
                            {[...Array(31).keys()].map(i => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col col-3">
                        <label>Inverter:&nbsp;</label>
                        <select
                            value={selectedInverter}
                            onChange={(e) => setSelectedInverter(e.target.value)}
                            className="form-select"
                        >
                            {[...Array(12).keys()].map(i => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Selección de fechas */}
                <div className="row mb-3">
                    <div className="col col-3">
                        <label>{t('scada.solarFarm.historical.startDate')}&nbsp;</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3">
                        <label>{t('scada.solarFarm.historical.endDate')}&nbsp;</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3 d-flex align-items-end">
                        <button onClick={handleConfirm} className="btn btn-primary me-2">{t('scada.solarFarm.historical.confirm')}</button>
                        <button onClick={handleReset} className="btn btn-secondary">{t('scada.solarFarm.historical.reset')}</button>
                    </div>
                </div>

                {/* Gráficos */}
                <div className="row">
                    <div className="col">
                        <object
                            data={`https://eurus.energynebula.com/grafana/d-solo/4bq30_iNk/scada-solar-inverter-data?orgId=1&var-ct=${selectedCt}&var-IdInverter=${Number(selectedInverter) + 10}&theme=light&panelId=2&from=${from}&to=${to}`}
                            width="100%"
                            height="400"
                            frameBorder="0"
                        ></object>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GrafHistoricosInv;
